import React from "react";
import { Helmet } from 'react-helmet-async';
import '../../../assets/styles/Dashboard.css'
import dashboardHero from "../../../assets/images/Dashboard Management.png";
import dashboardData from "../../../assets/images/Dashboard Management.png";

const MISDashboardPage = () => {
  return (
    <>
      <Helmet>
        {/* <!-- Primary Meta Tags for SEO --> */}
        <title> MIS Dashboards – BuddyTech Solutions </title>
        <meta name="description" content="Interactive dashboards for real-time insights and team collaboration." />
        <meta name="keywords" content="dashboard analytics, data visualization" />

        {/* <!-- Open Graph / Facebook Meta Tags --> */}
        <meta property="og:title" content="MIS Dashboards – BuddyTech Solutions" />
        <meta property="og:description" content="Interactive dashboards for real-time insights and team collaboration." />
        <meta property="og:keywords" content="dashboard analytics, data visualization" />
        <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
        <meta property="og:url" content="https://buddytechsolutions.in/services/mis/dashboard" />
        <meta property="og:type" content="website" />

        {/* <!-- Optional: Facebook App ID --> */}
        {/* <!-- <meta property="fb:app_id" content="your_facebook_app_id" /> --> */}

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="MIS Dashboards – BuddyTech Solutions" />
        <meta name="twitter:description" content="Interactive dashboards for real-time insights and team collaboration." />
        <meta name="twitter:keywords" content="dashboard analytics, data visualization" />
        <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
      </Helmet>
      <div className="dashboard-container">
        <header className="dashboard-hero">
          <div className="dashboard-hero-content">
            <h1>Interactive MIS Dashboards</h1>
            <p>
              We develop intuitive dashboards that offer real-time insights and visual analytics, enabling informed business decisions across all departments.
            </p>
          </div>
          <img src={dashboardHero} alt="Dashboard Hero" className="dashboard-hero-img" />
        </header>

        <section className="dashboard-section">
          <div className="dashboard-text">
            <h2>Features of Our Dashboards</h2>
            <p>
              Our dashboards consolidate key data sources into clean, user-friendly views that help teams monitor trends and improve performance.
            </p>
            <ul>
              <li>Custom KPI Tracking by Department</li>
              <li>Real-Time Performance Monitoring</li>
              <li>Data Filtering, Drill-Down & Export</li>
              <li>Role-Based Access & Views</li>
              <li>Automated Reporting Integration</li>
            </ul>
          </div>
          <img src={dashboardData} alt="Dashboard Data" className="dashboard-img" />
        </section>

        <section className="dashboard-tools">
          <h2>Tools & Platforms</h2>
          <div className="tools-grid">
            <span>Power BI</span>
            <span>Google Data Studio</span>
            <span>Tableau</span>
            <span>Looker Studio</span>
            <span>Metabase</span>
            <span>Grafana</span>
            <span>Excel Dashboards</span>
            <span>Zoho Analytics</span>
          </div>
        </section>
        <section className="contact-options">
          <div className="contact-card email">
            <h2>📧 Email</h2>
            <p>Send us an email for inquiries, support or collaboration opportunities.</p>
            <a href="mailto:Augustine.g.1992@gmail.com" target="_blank" rel="noopener noreferrer">
              Send Email
            </a>
          </div>

          <div className="contact-card whatsapp">
            <h2>💬 WhatsApp</h2>
            <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
            <a href="https://wa.me/917418763500" target="_blank" rel="noopener noreferrer">
              Chat on WhatsApp
            </a>
          </div>

          <div className="contact-card phone">
            <h2>📞 Call Us</h2>
            <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
            <a href="tel:+917418763500">Call Us</a>
          </div>
        </section>
      </div>
    </>
  );
};

export default MISDashboardPage;